// pages/Shop/EditShop.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  FaArrowLeft,
  FaStore,
  FaBuilding,
  FaEnvelope,
  FaGlobe,
  FaSave,
  FaImage,
  FaCity,
  FaFlag,
  FaMapMarkerAlt,
  FaTimes,
  FaChevronDown,
  FaChevronUp,
  FaCheckCircle
} from 'react-icons/fa';
import Swal from 'sweetalert2';
import axiosInstance, { BASE_URL } from '../../utils/axiosInstance';
import './Shop.css';

const EditShop = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [isCityDropdownOpen, setIsCityDropdownOpen] = useState(false);
  const [citySearch, setCitySearch] = useState('');

  const [formData, setFormData] = useState({
    shop_name: '',
    is_active: true,
    shop_email: '',
    shop_phone: '',
    shop_address: '',
    shop_logo: null,
    country: '',
    cities: []
  });

  const [errors, setErrors] = useState({});
  const [previewLogo, setPreviewLogo] = useState(null);
  const [currentLogo, setCurrentLogo] = useState(null);

  const citiesData = {
    'Pakistan': ['Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan', 'Hyderabad', 'Gujranwala', 'Peshawar', 'Quetta', 'Sialkot', 'Bahawalpur', 'Sukkur', 'Larkana', 'Mingora', 'Sargodha', 'Rahim Yar Khan', 'Jhang', 'Dera Ghazi Khan', 'Gujrat'],
    'United States': ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia', 'San Antonio', 'San Diego', 'Dallas', 'San Jose', 'Austin', 'Jacksonville', 'Fort Worth', 'Columbus', 'Charlotte'],
    'United Kingdom': ['London', 'Birmingham', 'Manchester', 'Glasgow', 'Liverpool', 'Bristol', 'Sheffield', 'Leeds', 'Edinburgh', 'Leicester', 'Coventry', 'Nottingham', 'Newcastle', 'Belfast', 'Southampton'],
    'Canada': ['Toronto', 'Vancouver', 'Montreal', 'Calgary', 'Edmonton', 'Ottawa', 'Winnipeg', 'Quebec City', 'Hamilton', 'Kitchener', 'London', 'Victoria', 'Halifax', 'Oshawa', 'Windsor'],
    'Australia': ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide', 'Gold Coast', 'Newcastle', 'Canberra', 'Wollongong', 'Hobart', 'Geelong', 'Townsville', 'Cairns', 'Darwin', 'Toowoomba'],
    'India': ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Ahmedabad', 'Chennai', 'Kolkata', 'Surat', 'Pune', 'Jaipur', 'Lucknow', 'Kanpur', 'Nagpur', 'Indore', 'Thane'],
    'Germany': ['Berlin', 'Hamburg', 'Munich', 'Cologne', 'Frankfurt', 'Stuttgart', 'Düsseldorf', 'Leipzig', 'Dortmund', 'Essen', 'Bremen', 'Dresden', 'Hannover', 'Nuremberg', 'Duisburg'],
    'France': ['Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice', 'Nantes', 'Strasbourg', 'Montpellier', 'Bordeaux', 'Lille', 'Rennes', 'Reims', 'Saint-Étienne', 'Toulon', 'Grenoble'],
    'Spain': ['Madrid', 'Barcelona', 'Valencia', 'Seville', 'Zaragoza', 'Málaga', 'Murcia', 'Palma', 'Las Palmas', 'Bilbao', 'Alicante', 'Córdoba', 'Valladolid', 'Vigo', 'Gijón'],
    'Italy': ['Rome', 'Milan', 'Naples', 'Turin', 'Palermo', 'Genoa', 'Bologna', 'Florence', 'Bari', 'Catania', 'Venice', 'Verona', 'Messina', 'Padua', 'Trieste'],
    'China': ['Shanghai', 'Beijing', 'Guangzhou', 'Shenzhen', 'Tianjin', 'Chongqing', 'Chengdu', 'Nanjing', 'Wuhan', 'Hangzhou', 'Xi\'an', 'Suzhou', 'Harbin', 'Taiyuan', 'Jinan'],
    'Japan': ['Tokyo', 'Yokohama', 'Osaka', 'Nagoya', 'Sapporo', 'Kobe', 'Kyoto', 'Fukuoka', 'Kawasaki', 'Saitama', 'Hiroshima', 'Sendai', 'Kitakyushu', 'Chiba', 'Sakai'],
    'Brazil': ['São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador', 'Fortaleza', 'Belo Horizonte', 'Manaus', 'Curitiba', 'Recife', 'Porto Alegre', 'Belém', 'Goiânia', 'Guarulhos', 'Campinas', 'São Luís'],
    'United Arab Emirates': ['Dubai', 'Abu Dhabi', 'Sharjah', 'Al Ain', 'Ajman', 'Ras Al Khaimah', 'Fujairah', 'Umm Al Quwain', 'Khor Fakkan', 'Dibba'],
    'Saudi Arabia': ['Riyadh', 'Jeddah', 'Mecca', 'Medina', 'Dammam', 'Khobar', 'Tabuk', 'Buraydah', 'Khamis Mushait', 'Al Hufuf'],
    'Turkey': ['Istanbul', 'Ankara', 'Izmir', 'Bursa', 'Antalya', 'Adana', 'Gaziantep', 'Konya', 'Mersin', 'Diyarbakir'],
    'Malaysia': ['Kuala Lumpur', 'George Town', 'Ipoh', 'Johor Bahru', 'Shah Alam', 'Petaling Jaya', 'Kuching', 'Kota Kinabalu', 'Malacca', 'Alor Setar'],
    'Singapore': ['Singapore', 'Bedok', 'Jurong East', 'Tampines', 'Woodlands', 'Bukit Batok', 'Punggol', 'Sengkang', 'Yishun', 'Choa Chu Kang'],
    'Bangladesh': ['Dhaka', 'Chittagong', 'Khulna', 'Rajshahi', 'Sylhet', 'Barisal', 'Rangpur', 'Comilla', 'Narayanganj', 'Mymensingh'],
    'Sri Lanka': ['Colombo', 'Kandy', 'Galle', 'Jaffna', 'Negombo', 'Trincomalee', 'Batticaloa', 'Anuradhapura', 'Ratnapura', 'Badulla'],
    'Nepal': ['Kathmandu', 'Pokhara', 'Lalitpur', 'Biratnagar', 'Bharatpur', 'Birgunj', 'Butwal', 'Dharan', 'Hetauda', 'Janakpur']
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith('http')) return imagePath;
    if (imagePath.startsWith('/media/')) return `${BASE_URL}${imagePath}`;
    return `${BASE_URL}/media/${imagePath}`;
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    setLoadingCountries(true);
    try {
      const response = await axiosInstance.get('/user/countries/');
      setCountries(response.data);
    } catch (error) {
      console.error('Error fetching countries:', error);
      const fallbackCountries = Object.keys(citiesData).map(countryName => ({
        code: countryName.substring(0, 2).toUpperCase(),
        name: countryName
      })).sort((a, b) => a.name.localeCompare(b.name));
      setCountries(fallbackCountries);
    } finally {
      setLoadingCountries(false);
    }
  };

  useEffect(() => {
    const fetchShop = async () => {
      try {
        setFetchLoading(true);
        const response = await axiosInstance.get(`/user/shops/${id}/`);
        const shopData = response.data;

        let citiesArray = [];
        if (shopData.cities) {
          if (typeof shopData.cities === 'string') {
            try { citiesArray = JSON.parse(shopData.cities); } catch { citiesArray = []; }
          } else if (Array.isArray(shopData.cities)) {
            citiesArray = shopData.cities;
          }
        }

        setFormData({
          shop_name: shopData.shop_name || '',
          is_active: shopData.is_active || false,
          shop_email: shopData.shop_email || '',
          shop_phone: shopData.shop_phone || '',
          shop_address: shopData.shop_address || '',
          shop_logo: null,
          country: shopData.country || '',
          cities: citiesArray
        });

        if (shopData.country && citiesData[shopData.country]) {
          const cityList = citiesData[shopData.country].map(city => ({
            name: city,
            selected: citiesArray.includes(city)
          }));
          setCities(cityList);
        }

        if (shopData.shop_logo) {
          setCurrentLogo(getImageUrl(shopData.shop_logo));
        }

        setErrors({});
      } catch (err) {
        console.error('Error fetching shop:', err);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load shop data. Please try again.',
          confirmButtonColor: '#004aad'
        });
        navigate('/shops');
      } finally {
        setFetchLoading(false);
      }
    };

    if (id) {
      fetchShop();
    } else {
      navigate('/shops');
    }
  }, [id, navigate]);

  const handleCountryChange = (e) => {
    const countryName = e.target.value;
    setFormData(prev => ({ ...prev, country: countryName, cities: [] }));
    if (countryName && citiesData[countryName]) {
      setCities(citiesData[countryName].map(city => ({ name: city, selected: false })));
    } else {
      setCities([]);
    }
    setIsCityDropdownOpen(false);
    setCitySearch('');
  };

  const toggleCitySelection = (cityName) => {
    setFormData(prev => {
      const currentCities = prev.cities || [];
      const isSelected = currentCities.includes(cityName);
      const newCities = isSelected
        ? currentCities.filter(c => c !== cityName)
        : [...currentCities, cityName];
      return { ...prev, cities: newCities };
    });

    setCities(prevCities =>
      prevCities.map(city =>
        city.name === cityName ? { ...city, selected: !city.selected } : city
      )
    );
  };

  const removeCity = (cityName) => {
    setFormData(prev => ({ ...prev, cities: prev.cities.filter(c => c !== cityName) }));
    setCities(prevCities =>
      prevCities.map(city =>
        city.name === cityName ? { ...city, selected: false } : city
      )
    );
  };

  const toggleCityDropdown = () => {
    if (formData.country) {
      setIsCityDropdownOpen(!isCityDropdownOpen);
      setCitySearch('');
    }
  };

  const filteredCities = cities.filter((city) =>
    city.name.toLowerCase().includes(citySearch.toLowerCase())
  );

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, shop_logo: file }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewLogo(reader.result);
        setCurrentLogo(null);
      };
      reader.readAsDataURL(file);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.shop_name.trim()) newErrors.shop_name = 'Shop name is required';
    if (!formData.country) newErrors.country = 'Please select a country';
    if (formData.cities.length === 0) newErrors.cities = 'Please select at least one city';
    if (formData.shop_email && !/\S+@\S+\.\S+/.test(formData.shop_email)) {
      newErrors.shop_email = 'Invalid email format';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      // ✅ SweetAlert for validation errors
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Please fill in all required fields correctly.',
        confirmButtonColor: '#004aad'
      });
      return;
    }

    setLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('shop_name', formData.shop_name);
      formDataToSend.append('is_active', formData.is_active ? 'true' : 'false');

      if (formData.shop_email) formDataToSend.append('shop_email', formData.shop_email);
      if (formData.shop_phone) formDataToSend.append('shop_phone', formData.shop_phone);
      if (formData.country) formDataToSend.append('country', formData.country);

      if (formData.cities && formData.cities.length > 0) {
        formDataToSend.append('cities', JSON.stringify(formData.cities));
      } else {
        formDataToSend.append('cities', JSON.stringify([]));
      }

      formDataToSend.append('shop_address', formData.shop_address || '');
      if (formData.shop_logo) formDataToSend.append('shop_logo', formData.shop_logo);

      const response = await axiosInstance.patch(
        `/user/shops/${id}/`,
        formDataToSend,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.status === 200) {
        // ✅ SweetAlert Success
        await Swal.fire({
          icon: 'success',
          title: 'Shop Updated!',
          text: 'Your shop has been updated successfully.',
          confirmButtonColor: '#004aad',
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: true
        });
        navigate('/shops');
      }
    } catch (err) {
      console.error('Error updating shop:', err);

      if (err.response && err.response.data) {
        const data = err.response.data;

        if (data.errors && typeof data.errors === 'object') {
          const fieldErrors = {};
          Object.keys(data.errors).forEach((k) => {
            const v = data.errors[k];
            fieldErrors[k] = Array.isArray(v) ? v[0] : String(v);
          });
          setErrors(fieldErrors);

          // ✅ SweetAlert for field errors
          const errorMessages = Object.values(fieldErrors).join('\n');
          Swal.fire({
            icon: 'error',
            title: 'Validation Failed',
            text: errorMessages,
            confirmButtonColor: '#004aad'
          });
        } else {
          const errorMessage = typeof data === 'string'
            ? data
            : data.error || data.detail || data.message || 'Failed to update shop. Please try again.';

          // ✅ SweetAlert for API error
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            confirmButtonColor: '#004aad'
          });
        }
      } else {
        // ✅ SweetAlert for network/generic error
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to update shop. Please try again.',
          confirmButtonColor: '#004aad'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  if (fetchLoading) {
    return (
      <div className="edit-shop-container">
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading shop data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="add-shop-page">
      <div className="add-shop-header">
        <button className="back-button" onClick={() => navigate('/shops')}>
          Back to Shops
        </button>
        <div className="header-title">
          <h1>Edit Shop</h1>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="add-shop-form">
        <div className="form-grid">
          {/* ============== BASIC INFORMATION ============== */}
          <div className="form-section">
            <h3>
              <FaBuilding className="section-icon" />
              Basic Information
            </h3>

            <div className="form-group">
              <label>Shop Name *</label>
              <input
                type="text"
                name="shop_name"
                value={formData.shop_name}
                onChange={handleInputChange}
                className={errors.shop_name ? 'error' : ''}
              />
              {errors.shop_name && <span className="error-message">{errors.shop_name}</span>}
            </div>

            <div className="form-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleInputChange}
                />
                <span className="checkbox-label">Active Status</span>
              </label>
            </div>
          </div>

          {/* ============== CONTACT INFORMATION ============== */}
          <div className="form-section">
            <h3>
              <FaEnvelope className="section-icon" />
              Contact Information
            </h3>

            <div className="form-group">
              <label>Email Address *</label>
              <input
                type="email"
                name="shop_email"
                value={formData.shop_email}
                onChange={handleInputChange}
                className={errors.shop_email ? 'error' : ''}
              />
              {errors.shop_email && <span className="error-message">{errors.shop_email}</span>}
            </div>

            <div className="form-group">
              <label>Phone Number *</label>
              <input
                type="tel"
                name="shop_phone"
                value={formData.shop_phone}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>Street Address *</label>
              <textarea
                name="shop_address"
                value={formData.shop_address}
                onChange={handleInputChange}
                rows="3"
              />
            </div>
          </div>

          {/* ============== LOCATION INFORMATION ============== */}
          <div className="form-section">
            <h3>
              <FaGlobe className="section-icon" />
              Location Information
            </h3>

            <div className="form-group">
              <label>
                <FaFlag className="field-icon" />
                Country *
              </label>
              <select
                name="country"
                value={formData.country}
                onChange={handleCountryChange}
                className={errors.country ? 'error' : ''}
                disabled={loadingCountries}
              >
                <option value="">-- Select Country --</option>
                {countries.map((country) => (
                  <option key={country.code} value={country.name}>{country.name}</option>
                ))}
              </select>
              {loadingCountries && <p className="field-hint">Loading countries...</p>}
              {errors.country && <span className="error-message">{errors.country}</span>}
            </div>

            <div className="form-group">
              <label>
                <FaCity className="field-icon" />
                Cities / Towns * (Select multiple)
              </label>

              {formData.cities && formData.cities.length > 0 && (
                <div className="selected-cities-container">
                  {formData.cities.map((city, index) => (
                    <span key={index} className="city-tag">
                      {city}
                      <button type="button" className="city-tag-remove" onClick={() => removeCity(city)}>
                        <FaTimes />
                      </button>
                    </span>
                  ))}
                </div>
              )}

              <div className="city-select-wrapper">
                <button
                  type="button"
                  className={`city-dropdown-toggle ${errors.cities ? 'error' : ''}`}
                  onClick={toggleCityDropdown}
                  disabled={!formData.country}
                >
                  <span className="city-dropdown-text">
                    {formData.cities.length > 0
                      ? `${formData.cities.length} city(ies) selected`
                      : formData.country ? 'Select cities...' : 'Please select a country first'}
                  </span>
                  {isCityDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
                </button>

                {isCityDropdownOpen && formData.country && (
                  <div className="city-dropdown-menu">
                    <div className="city-search">
                      <input
                        type="text"
                        placeholder="Search cities..."
                        className="city-search-input"
                        value={citySearch}
                        onChange={(e) => setCitySearch(e.target.value)}
                      />
                    </div>
                    <div className="city-dropdown-list">
                      {filteredCities.length === 0 ? (
                        <div className="city-dropdown-empty">No cities available</div>
                      ) : (
                        filteredCities.map((city, index) => (
                          <div
                            key={index}
                            className={`city-dropdown-item ${city.selected ? 'selected' : ''}`}
                            onClick={() => toggleCitySelection(city.name)}
                            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                          >
                            <span className="city-name" style={{ color: '#333', fontSize: '14px', flex: 1 }}>
                              {city.name}
                            </span>
                            {city.selected && (
                              <FaCheckCircle style={{ color: '#004aad', marginLeft: 'auto' }} />
                            )}
                          </div>
                        ))
                      )}
                    </div>
                    <div className="city-dropdown-footer">
                      <button type="button" className="city-dropdown-close" onClick={() => setIsCityDropdownOpen(false)}>
                        Close
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {!formData.country && <p className="field-hint">Please select a country first to see cities</p>}
              {errors.cities && <span className="error-message">{errors.cities}</span>}
            </div>
          </div>

          {/* ============== SHOP LOGO ============== */}
          <div className="form-section">
            <h3>
              <FaImage className="section-icon" />
              Shop Logo
            </h3>

            <div className="logo-upload-container">
              <div className="logo-preview">
                {previewLogo ? (
                  <img src={previewLogo} alt="Shop logo preview" className="logo-preview-image" />
                ) : currentLogo ? (
                  <img src={currentLogo} alt="Current shop logo" className="logo-preview-image" />
                ) : (
                  <div className="logo-placeholder">
                    <FaStore className="placeholder-icon" />
                    <span>No logo uploaded</span>
                  </div>
                )}
              </div>

              <div className="logo-upload-controls">
                <label className="upload-button">
                  <FaImage />
                  <span>Change Logo</span>
                  <input type="file" accept="image/*" onChange={handleFileChange} style={{ display: 'none' }} />
                </label>
                <p className="field-hint">Recommended size: 200x200px. Max file size: 2MB</p>
              </div>
            </div>
          </div>
        </div>

        {/* ============== FORM ACTIONS ============== */}
        <div className="form-actions">
          <button type="button" className="cancel-btn" onClick={() => navigate('/shops')}>
            Cancel
          </button>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditShop;